import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState } from 'react';
import { bool, func, shape, string, arrayOf } from 'prop-types';
import { DEFAULT_SELLER } from '../../constants';
import { Dialog } from '../../atoms';
import Sidebar, { SidebarHeader } from '../Sidebar';
import ContentBox from './content-box';
import GuaranteeDetails from './guarantee-details';

const DeliveryGuarantee = _ref => {
  let {
    seller,
    showDialog,
    detailsText,
    detailsTitle,
    isMagaluCompany,
    onDetailsOpen,
    onDetailsClose
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["seller", "showDialog", "detailsText", "detailsTitle", "isMagaluCompany", "onDetailsOpen", "onDetailsClose"]);

  const {
    id
  } = seller;
  const [showDetails, setShowDetails] = useState(false);

  const openDetails = e => {
    onDetailsOpen(e);
    setShowDetails(true);
  };

  const closeDetails = e => {
    onDetailsClose(e);
    setShowDetails(false);
  };

  if (id === DEFAULT_SELLER) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ContentBox, _extends({
    isMagaluCompany: isMagaluCompany,
    onLinkClick: openDetails
  }, props)), !showDialog && /*#__PURE__*/React.createElement(Sidebar, {
    direction: "right",
    visible: showDetails,
    onClickOutside: closeDetails,
    fullScreen: false
  }, /*#__PURE__*/React.createElement(SidebarHeader, {
    label: isMagaluCompany ? 'Empresa do Grupo Magalu' : 'Entrega e compra garantida',
    align: "left",
    fontSize: 3,
    leftButton: {
      icon: 'back',
      title: 'Voltar para a pagina do produto',
      onClick: closeDetails
    }
  }), /*#__PURE__*/React.createElement(GuaranteeDetails, {
    text: detailsText,
    title: detailsTitle
  })), showDialog && /*#__PURE__*/React.createElement(Dialog, {
    visible: showDetails,
    onClickOutside: closeDetails,
    type: "responsive",
    position: "center",
    width: "350px",
    titleStyle: {
      textAlign: 'center'
    },
    showClose: true
  }, /*#__PURE__*/React.createElement(GuaranteeDetails, {
    text: detailsText,
    title: detailsTitle
  })));
};

process.env.NODE_ENV !== "production" ? DeliveryGuarantee.propTypes = {
  seller: shape({
    id: string
  }),
  detailsText: arrayOf(string),
  detailsTitle: string,
  isMagaluCompany: bool,
  showDialog: bool,
  onDetailsOpen: func,
  onDetailsClose: func
} : void 0;
DeliveryGuarantee.defaultProps = {
  seller: {
    id: 'magazineluiza'
  },
  detailsText: [],
  detailsTitle: '',
  showDialog: false,
  isMagaluCompany: false,
  onDetailsOpen: () => {},
  onDetailsClose: () => {}
};
export default DeliveryGuarantee;